import React from 'react';
import { Box } from '@mui/material';
import { usePWAStatus } from '../../hooks/usePWAStatus';

/**
 * Layout wrapper that provides proper spacing when bottom navigation is active
 */
const AppLayout = ({ children }) => {
    const { isPWA } = usePWAStatus();

    return (
        <Box
            sx={{
                // Add bottom padding when PWA mode is active to prevent content from being covered by bottom nav
                paddingBottom: isPWA ? '110px' : 0,
                // Ensure smooth transitions
                transition: 'padding-bottom 0.3s ease'
            }}
        >
            {children}
        </Box>
    );
};

export default AppLayout;